module.exports = __webpack_public_path__ + "static/qh_23.f745f11c.jpg";